var _defs, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAjouter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    className: "mainStroke",
    "data-name": "Layer 1",
    width: 150,
    height: 150,
    id: "Layer_1",
    viewBox: "0 0 50 50",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\r\n      .cls-1 {\r\n        fill-rule: evenodd;\r\n        stroke-width: 0px;\r\n      }\r\n    "))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m24.78,14.15c-.41.07-.4-.02-.44,5.22l-.04,4.92-4.93.04c-5.55.05-5.21,0-5.21.67s-.33.62,5.21.67l4.93.04.04,4.93c.05,5.55,0,5.21.67,5.21s.62.33.67-5.21l.04-4.93,4.93-.04c5.55-.05,5.21,0,5.21-.67s.33-.62-5.21-.67l-4.93-.04-.04-4.93c-.05-5.35-.02-5.12-.5-5.21-.13-.02-.26-.02-.39,0"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAjouter);
export default __webpack_public_path__ + "static/media/ajouter.77606b19f3debf661bdbc28f1f7f7d91.svg";
export { ForwardRef as ReactComponent };